<template>
  <!-- 指标总览 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">指标总览</span>
    </div>
    <div class="warpTop">
      <div class="echartWarp">
        <div id="main" class="echartStyle"></div>
        <div class="lastYear">
          <span class="lastYear-title">上年漏损率</span>
          <span class="lastYear-num">
            {{ model.lastLeakageRate }}
            <span class="unit">%</span>
          </span>
        </div>
        <!-- <DashboardChart></DashboardChart> -->
      </div>
      <div class="monthWarp">
        <div class="monthItem" v-for="(item, index) in monthData" :key="index">
          <img :src="item.imgUrl" />
          <div class="titleWarp">
            <span class="itemTitle">{{ item.title }}</span>
            <span class="itemNum">
              {{ item.num }}
              <span class="unit">{{ item.unit }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="warpBottom">
      <div class="bottomItem" v-for="(item, index) in bottomList" :key="index + 0.1">
        <div class="botmItem-Top">
          <span>
            <img src="~@/assets/myImg/1/h_1_sjx.png" />
            <span class="botmItem-TopTitle">{{ item.title }}</span>
          </span>
          <span class="botmItem-TopNum">
            {{ item.num }}
            <span class="unit2">{{ item.unit }}</span>
          </span>
        </div>
        <div class="botmItem-bottom">
          <span class="botmItem-bottomTitle">本年新增</span>
          <span class="unit2">{{ item.add }}{{ item.unit }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import DashboardChart from '@/components/Charts/DashboardChart'
export default {
  name: 'OverviewIndicators',
  components: {},
  data () {
    return {
      leakageRate: 2.33,
      model: {},
      url: '/pipe-network/water_company_indicators/page',
      arrUrl: '/pipe-network/report/chart/indicator/data',
      monthData: [
        {
          title: '月总供水量',
          imgUrl: require('@/assets/myImg/1/h_1_gs.png'),
          // num: 583050,
          unit: 'm³'
        },
        {
          title: '月总售水量',
          imgUrl: require('@/assets/myImg/1/h_1_js.png'),
          // num: 569461,
          unit: 'm³'
        },
        {
          title: '月总耗电量',
          imgUrl: require('@/assets/myImg/1/h_1_hdl.png'),
          // num: 36814,
          unit: 'Kw.h'
        }
      ],
      bottomList: [
        // {
        //   title: '管网',
        //   // num: 231,
        //   // add: 21,
        //   unit: 'km'
        // },
        // {
        //   title: '用户',
        //   // num: 28634,
        //   // add: 886,
        //   unit: '户'
        // },
        // {
        //   title: '阀门',
        //   // num: 914,
        //   // add: 59,
        //   unit: '个'
        // }
      ]
    }
  },
  created () {
    this.$nextTick(() => {
      this.getDataList()
    })
  },
  mounted () { },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    getIndicatorData () {
      this.$http.get(this.arrUrl).then(res => {
        console.log('res', res)
        const { data } = res
        //data.monthlyWaterSupply = '564396.00'
        // 564396.00
        // this.monthData[0].num = data.monthlyWaterSupply
        // 管网
        this.bottomList[0].num = data.pipelineMaterialSum
        this.bottomList[0].add = data.pipelineMaterialCount
        // 用户
        this.bottomList[1].num = data.userSum
        this.bottomList[1].add = data.userCount
        // 阀门
        this.bottomList[2].num = data.gateValveSum
        this.bottomList[2].add = data.gateValveCount
      })
    },
    getDataList () {
      this.$http.get(this.url).then(res => {
        const model = res.data.list[0]

        this.model = res.data.list[0]
        this.leakageRate = parseFloat(model.leakageRate)
        this.monthData = [
          {
            title: '月总供水量',
            imgUrl: require('@/assets/myImg/1/h_1_gs.png'),
            num: model.waterDelivery,
            unit: 'm³'
          },
          {
            title: '月总售水量',
            imgUrl: require('@/assets/myImg/1/h_1_js.png'),
            num: model.waterSell,
            unit: 'm³'
          },
          {
            title: '月总耗电量',
            imgUrl: require('@/assets/myImg/1/h_1_hdl.png'),
            num: model.waterPower,
            unit: 'Kw.h'
          }
        ]
        this.bottomList = [
          {
            title: '管网',
            num: model.pipeLeght,
            add: model.pipeLeghtYear,
            unit: 'km'
          },
          {
            title: '用户',
            num: model.userSum,
            add: model.userSumYear,
            unit: '户'
          },
          {
            title: '阀门',
            num: model.valveSum,
            add: model.valveSumYear,
            unit: '个'
          }
        ]
        this.$nextTick(() => {
          this.queryData()
          this.getEchartData()
          // this.getIndicatorData()
        })
      })
    },
    getEchartData () {
      this.timer = setInterval(() => {
        this.queryData()
        // 你获取echarts数据的方法
      }, 1000 * 10)
    },
    queryData () {
      var chartDom = document.getElementById('main')
      var myChart = echarts2.init(chartDom)
      var option
      option = {
        series: [
          {
            center: ['50%', '46%'],
            radius: '90%',
            type: 'gauge',
            startAngle: 220,
            endAngle: -40,
            min: 0,
            max: 2.6,
            roundCap: true,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#297FFE' }, // 柱图渐变色
                { offset: 1, color: '#08E5FF' } // 柱图渐变色
              ]),
              shadowColor: '#297FFE',
              shadowBlur: 10,
              shadowOffsetX: 2,
              shadowOffsetY: 2
            },
            progress: {
              // show:false,
              roundCap: true,
              show: true,
              width: 12
            },
            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 12
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            pointer: {
              show: false
            },
            title: {
              show: false,
              color: '#00EBEE',
              fontSize: 14,
              offsetCenter: [0, '80%']
            },
            detail: {
              valueAnimation: true,
              fontSize: 80,
              offsetCenter: [0, '0%'],
              formatter: function (value) {
                return '{value|' + value + '}{unit|%}'
              },
              rich: {
                value: {
                  fontSize: 28,
                  fontWeight: 'bolder',
                  color: '#15A9F1'
                },
                unit: {
                  fontSize: 12,
                  color: '#15A9F1',
                  padding: [0, 0, -10, 10]
                }
              }
            },
            data: [
              {
                value: this.leakageRate,
                name: '月漏损率'
              }
            ]
          }
        ]
      }
      myChart.clear()
      option && myChart.setOption(option)
    }
  }
}
</script>

<style lang="less" scoped>
.unit {
  font-family: MicrosoftYaHeiSemibold;
  font-size: 12px;
  color: #15a9f1;
  font-weight: 600;
}

.unit2 {
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #15a9f1;
  font-weight: 600;
}

.mainWarp {
  height: 586px;
  width: 408px;
  padding: 0 20px;
  background: url(~@/assets/myImg/h_1_01_box.png) no-repeat;
  background-size: contain;
  position: relative;
  box-sizing: border-box;

  .img-title {
    position: absolute;
    position: relative;
    top: -20px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      //   position: absolute;
      width: 264px;
      height: 40px;
    }
  }

  .warpTop {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .echartWarp {
      width: 166px;
      height: 212px;
      display: flex;
      flex-direction: column;

      .echartStyle {
        width: 186px;
        height: 156px;
      }

      .lastYear {
        height: 62px;
        width: 166px;
        background: url(~@/assets/myImg/1/content-box-02.png) no-repeat;
        background-size: contain;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;

        .lastYear-title {
          font-family: MicrosoftYaHeiSemibold;
          font-size: 14px;
          color: #00ebee;
          font-weight: 600;
        }

        .lastYear-num {
          font-family: MicrosoftYaHeiSemibold;
          font-size: 22px;
          color: #15a9f1;
          font-weight: 600;
        }
      }
    }

    .monthWarp {
      height: 212px;
      width: 186px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .monthItem {
        height: 60px;
        width: 186px;
        padding: 6px 14px;
        padding-right: 0px;
        background: url(~@/assets/myImg/1/content-box-01.png) no-repeat;
        background-size: contain;
        overflow: visible;
        display: flex;
        align-items: center;

        img {
          width: 30px;
          height: 30px;
        }

        .titleWarp {
          margin-left: 10px;
          display: flex;
          flex-direction: column;

          .itemTitle {
            font-family: MicrosoftYaHeiSemibold;
            font-size: 14px;
            color: #00ebee;
            font-weight: 500;
          }

          .itemNum {
            display: inline;
            font-family: MicrosoftYaHeiSemibold;
            // font-size: 14px;
            font-size: 18px;
            // width: 80px;
            overflow: hidden;
            color: #15a9f1;
            font-weight: 600;
          }
        }
      }
    }
  }

  .warpBottom {
    margin-top: 16px;
    height: 296px;
    width: 368px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .bottomItem {
      width: 368px;
      height: 88px;
      background: url(~@/assets/myImg/1/content-box-03.png) no-repeat;
      background-size: contain;
      padding: 12px 16px;

      .botmItem-Top {
        width: 336px;
        height: 32px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        img {
          height: 9px;
          width: 9px;
        }

        .botmItem-TopTitle {
          font-family: MicrosoftYaHeiSemibold;
          font-size: 18px;
          color: #00ebee;
          font-weight: 600;
          margin-left: 13px;
        }

        .botmItem-TopNum {
          font-family: MicrosoftYaHeiSemibold;
          font-size: 22px;
          color: #15a9f1;
          text-align: right;
          font-weight: 600;
        }
      }

      .botmItem-bottom {
        width: 336px;
        height: 32px;
        padding: 0 10px;
        background-image: linear-gradient(270deg, rgba(7, 42, 80, 0.35) 0%, rgba(84, 169, 255, 0.25) 100%);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .botmItem-bottomTitle {
          font-family: MicrosoftYaHei;
          font-size: 16px;
          color: #15a9f1;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
